/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import {
  DataSet,
  DataSetBody,
  DataSetUpdateBody
} from '../../pages/Datasets/types'
import { createGenericSlice, GenericState } from '../lib'

const sliceName = 'datasets'

//todo need to reverse this and use the sate as the type
export interface DataSetState extends GenericState<DataSet> {}

export const getAllDatasets = createAsyncThunk(
  `${sliceName}/getAllDatasets`,
  async (_, { rejectWithValue }) => {
    try {
      return await Services.getAllDatasets()
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getAllDatasetsType = createAsyncThunk(
  `${sliceName}/getAllDatasetsType`,
  async (dataSetType: string, { rejectWithValue }) => {
    try {
      const datasetType = dataSetType === 'Ingress' ? 'dynamic' : 'static'
      return await Services.getAllDatasetsType(datasetType)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getDataset = createAsyncThunk(
  `${sliceName}/getDataset`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getDataset(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createDataset = createAsyncThunk(
  `${sliceName}/createDataset`,
  async (body: DataSetBody, { rejectWithValue }) => {
    try {
      return await Services.createDataset(body)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const updateDataset = createAsyncThunk(
  `${sliceName}/updateDataset`,
  async (
    data: { id: string; body: DataSetUpdateBody },
    { rejectWithValue }
  ) => {
    try {
      return await Services.updateDataset(data)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeDataset = createAsyncThunk(
  `${sliceName}/removeDataset`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.removeDataset(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const datasetsAdapter = createEntityAdapter<DataSet>()

//TODO fix type issue and replace any
const thunkAdapters: any = [
  {
    adapterFn: datasetsAdapter.setAll,
    thunk: getAllDatasets
  },
  {
    adapterFn: datasetsAdapter.setAll,
    thunk: getAllDatasetsType
  },
  {
    adapterFn: datasetsAdapter.upsertOne,
    thunk: getDataset
  },
  {
    adapterFn: datasetsAdapter.upsertOne,
    thunk: createDataset
  },
  {
    adapterFn: datasetsAdapter.upsertOne,
    thunk: updateDataset
  },
  {
    adapterFn: datasetsAdapter.removeOne,
    thunk: removeDataset
  }
]

export const initialDatasetsState: DataSetState = {
  loading: false,
  error: null,
  ids: [],
  entities: {}
}

export const datasetsSlice = createGenericSlice({
  name: sliceName,
  initialState: initialDatasetsState,
  thunkAdapters
})
